<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('orgChartLevel.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('orgChartLevel.company') }}</label>
              <div>
                <ts-select
                  v-model="model.company_id"
                  :options="
                    companies.map(company => ({
                      value: company.company_id,
                      text: company.company_name_en
                    }))
                  "
                  :class="{ 'is-invalid': errors.has('company_id') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('company_id')">
                  {{ errors.first('company_id') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('orgChartLevel.levelDescription') }}</label>
              <div>
                <ts-input
                  v-model="model.level_description"
                  :class="{ 'is-invalid': errors.has('level_description') }"
                />
                <div class="invalid-feedback" v-if="errors.has('level_description')">
                  {{ errors.first('level_description') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="submit">{{
              editData ? $t('button.update') : $t('button.create')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'org-chart-level-form',
  props: ['editData', 'companies'],
  data() {
    return {
      model: {
        level_description: this.editData ? this.editData.level_description : '',
        company_id: this.editData ? this.editData.company_id : ''
      },
      errors: new Errors(),
      saving: false
    }
  },
  created() {},
  methods: {
    submit() {
      let response

      this.errors = new Errors()
      this.saving = true

      if (this.editData) {
        response = this.$store.dispatch('hr/orgChartLevel/update', {
          id: this.editData.org_id,
          ...this.model
        })
      } else {
        response = this.$store.dispatch('hr/orgChartLevel/create', this.model)
      }

      response
        .then(response => {
          this.$store.dispatch('hr/orgChartLevel/fetch').then(() => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
          })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>
